
import { i18nText } from '@/locales';

import {Component, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {ClientsStore} from "@/store/modules/Clients";
import {Tabs} from 'ant-design-vue'
import {message} from "ant-design-vue";
import {RouterNameEnum} from "@/router/router.types";
import Badge from "@/UI/components/common/Badge.vue";
import {mixins} from "vue-class-component";
import {PaginationMix} from "@/UI/mixins/PaginationMix";
import {VisitsMix} from "@/UI/mixins/Clients/VisitsMix";
import {tabs} from "@/UI/pages/clients/lib/tabs"
import {getStudioId} from "@/UI/lib/state";

@Component({
  components: {
    PageTitle,
    Badge,
    "a-tab-pane": Tabs.TabPane,
  },
})

export default class ClientDetail extends mixins(
  PaginationMix,
  VisitsMix,
) {
  formReady = false;
  loadError = '';
  tabs = tabs;
  defaultTabKey: string | null = RouterNameEnum.ClientDetailCommon;
  tab = 1

  clientDeleteMessage(client: string): string {
    return i18nText("Вы действительно хотите удалить ") + client;
  }

  async deleteClient(): Promise<void> {
    const response = await ClientsStore.delete({id: parseInt(this.$route.params.id)});
    if (response.status) {
      message.success(i18nText("Данные успешно удалены"));
      await this.$router.push({name: RouterNameEnum.Clients});
    } else {
      message.error(response.response);
    }
  }

  async created(): Promise<void> {
    const currentTab = tabs.find((el) => el.id === this.$route.name ||
      (el.aliases && this.$route.name && el.aliases.includes(this.$route.name.toString())));
    if (currentTab) {
      this.defaultTabKey = currentTab.id;
    }

    try {
      await ClientsStore.fetchData({filter: {id: parseInt(this.$route.params.id)}});
      if (this.client?.salon_id && Number(this.$store.state.salon_id) !== Number(this.client.salon_id)) this.$store.commit('changeSalon', this.client.salon_id);
      if (!this.client) this.loadError = i18nText("Клиент не найден или недоступен.");
    } catch (e) {
      this.loadError = i18nText("Не удалось загрузить клиента. Обновите страницу.");
    } finally {
      this.formReady = true;
    }
  }

  async tabChanged(key: string): Promise<void> {
    try {
      this.formReady = false
      let params: any = {
        id: String(this.client.id),
        page: '1',
        total: '10',
        filter: '{}',
        sorted: '{}'
      }
      if (key === 'ClientDetailHistoryPage') {
        params.filter = JSON.stringify({
          salon_id: getStudioId(this),
          status_id: 2,
          client_id: Vue.router.currentRoute.params['id']
        })
        params.sorted = JSON.stringify({
          sort: 'visit_dt',
          by: 'desc'
        })
      }
      if (key === 'ClientDetailNotesPage') {
        params.filter = JSON.stringify({
          salon_id: getStudioId(this),
          client_id: Vue.router.currentRoute.params['id']
        })
      }
      if (key === RouterNameEnum.ClientDetailAccountsPage) {
        params.filter = JSON.stringify({
          client_id: Vue.router.currentRoute.params['id']
        })
        params.sorted = JSON.stringify({
          sort: 'created_at',
          by: 'desc'
        })
      }
      if (key === 'ClientDetailLoyaltyPage') {
        console.log('params id', Vue.router.currentRoute.params)
        params.filter = JSON.stringify({
          client_id: Vue.router.currentRoute.params['id']
        })
        params.sorted = JSON.stringify({
          sort: 'created_at',
          by: 'desc'
        })
      }

      await Vue.router.push({
        name: key,
        params: params
      })
      this.defaultTabKey = key;
    } catch (e) {
      console.error(e)
    } finally {
      this.formReady = true
    }
  }

  get client(): any {
    return ClientsStore.client
  }
}
